<template>
  <div class="risk-map" ref="riskMap">
    <l-map
      id="map"
      ref="map"
      :center="defaultCenter"
      :zoom="defaultZoom"
      :minZoom="4"
      :maxZoom="14"
      :zoomAnimation="false"
      :options="{
        zoomControl: false,
      }"
      @ready="updateMapObject()"
    >
      <template v-if="mapObject">
        <base-tile-layer></base-tile-layer>
        <rain-ensemble-layer
          :calendar-date="calendarDate"
        ></rain-ensemble-layer>
        <l-control position="bottomright">
          <v-row no-gutters align="center">
            <v-col cols="auto" class="mr-2">
              <vue-ctk-date-time-picker
                v-model="calendarDate"
                :no-value-to-custom-elem="true"
                format="YYYY/MM/DD HH:mm"
                formatted="YYYY/MM/DD HH:mm"
                output-format="YYYY-MM-DD HH:mm"
                :overlay="true"
                :no-header="true"
                locale="ja"
                size="sm"
                right
                noLabel
                noClearButton
                no-button-now
                color="#3a1e87"
              >
              </vue-ctk-date-time-picker>
            </v-col>
            <v-col>
              <v-btn @click="updateCalendarDateToNow"> NOW </v-btn>
            </v-col>
          </v-row>
        </l-control>
      </template>
    </l-map>
  </div>
</template>
<script>
import { UPDATE_MAP_OBJECT } from "@/store/mutation-types";
import RainEnsembleLayer from "@/components/risk-map-view/layers/RainEnsembleLayer";
import BaseTileLayer from "@/components/risk-map-view/layers/BaseTileLayer";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment";

export default {
  name: "TestView",
  components: {
    BaseTileLayer,
    RainEnsembleLayer,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      value: "2018-04-05T04:26",
      defaultCenter: { lat: 35.5, lng: 136 },
      defaultZoom: 7,
      calendarDate: moment().format("YYYY/MM/DD HH:mm"),
    };
  },
  computed: {
    mapObject() {
      return this.$store.state.map;
    },
  },
  mounted() {
    this.$nextTick(() => {
      let resize;
      window.onresize = () => {
        clearTimeout(resize);
        resize = setTimeout(this.onResize, 100);
      };
      this.onResize();
    });
  },
  beforeDestroy() {
    this.$store.commit(UPDATE_MAP_OBJECT, { map: null });
  },
  methods: {
    onResize() {
      document.body.style.height = window.innerHeight + "px";
      this.$refs.riskMap.style.height = window.innerHeight + "px";
      this.mapObject.invalidateSize();
    },
    updateMapObject() {
      const mapObject = this.$refs.map.mapObject;
      this.$store.commit(UPDATE_MAP_OBJECT, { map: mapObject });
    },
    updateCalendarDateToNow() {
      this.calendarDate = moment().format("YYYY/MM/DD HH:mm");
    },
  },
};
</script>
<style lang="scss">
.leaflet-pane.leaflet-tile-pane .leaflet-layer:nth-child(1) {
  filter: blur(0px) brightness(89%) contrast(100%) grayscale(8%)
    hue-rotate(309deg) opacity(100%) invert(0%) saturate(131%) sepia(2%);
}
.leaflet-bottom.leaflet-right
  .leaflet-control-attribution.leaflet-control:last-child {
  display: none;
}
</style>
<style lang="scss" scoped>
.risk-map {
  position: relative;
  width: 100%;
  overflow: hidden;
}
#map {
  width: 100%;
  height: 100%;
}
.controller-area {
  position: absolute;
  background-color: $base-color;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
